<template>
    <g>
        <path style="fill:#281F1F;" d="M64.6,43.4c-2-0.4-3.7-0.1-5.7,0.9c-0.4,0.2-1.1,0.8-1,0.8c1-0.4,2.1-0.6,3.1-0.6c0,0.2,0,0.4,0,0.6
			c0,0.3,0.1,0.7,0.3,0.9c1,0,2.1,0.1,3.2,0c0.2-0.3,0.3-0.6,0.3-0.9c0-0.2,0-0.4-0.1-0.5c1.8,0.2,3,0.6,3.1,0.6
			C67.8,45.1,66.9,43.8,64.6,43.4z"/>
        <path style="fill:#281F1F;" d="M49.1,44.3c-1.9-1-3.7-1.3-5.7-0.9c-2.2,0.4-3.1,1.7-3.2,1.8c0.1,0,1.3-0.4,3.1-0.6c-0.1,0.2-0.1,0.4-0.1,0.5
			c0,0.3,0.1,0.7,0.3,0.9c1.1,0,2.2,0,3.2,0c0.2-0.3,0.3-0.6,0.3-0.9c0-0.2-0.1-0.5-0.2-0.7c1.1,0.1,2.1,0.3,3.1,0.6
			C50.2,45.1,49.5,44.5,49.1,44.3z"/>
        <path style="fill:#281F1F;" d="M69,40.8c-1-0.8-2.2-1.8-4.1-2c-1-0.1-4.2,0.7-6,1c-0.3,0.6-0.5,0.8-0.8,1.5c1.9-0.6,4.1-1,6-1.2
			C66.3,39.9,66.8,40.2,69,40.8z"/>
        <path style="fill:#281F1F;" d="M44,40.1c1.9,0.2,4.1,0.7,6,1.2c-0.3-0.7-0.5-0.8-0.8-1.5c-1.8-0.3-5-1.1-6-1c-2,0.2-3.2,1.2-4.2,2
			C41.3,40.2,41.8,39.9,44,40.1z"/>
    </g>
</template>

<script>
    export default {
        name: 'Eye15',
    }
</script>

